import { useState } from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Loader } from "@/components/shared/loader";
import { useDeleteUser } from "@/features/users/hooks/useUsersMutations";

interface DeleteUserDialogProps {
  userId: string;
}

/** Super Admin only. "Delete" hides the account from the list; nothing is removed from the database. */
export function DeleteUserDialog({ userId }: DeleteUserDialogProps) {
  const [open, setOpen] = useState(false);
  const { mutateAsync, isPending } = useDeleteUser();

  const handleDelete = async () => {
    try {
      await mutateAsync(userId);
      setOpen(false);
    } catch {
      /* useDeleteUser.onError handles errors */
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center justify-center text-gray-600 hover:text-red-600 transition-colors"
          aria-label="حذف المستخدم"
          title="حذف المستخدم"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="text-right">
          <DialogTitle>حذف المستخدم</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-gray-600 text-right mb-4">
          سيتم إخفاء هذا المستخدم من قائمة المستخدمين وإيقاف دخوله فوراً. تبقى
          بياناته وسجل نشاطه محفوظة في النظام.
        </p>
        <Button
          type="button"
          variant="destructive"
          disabled={isPending}
          onClick={handleDelete}
          className="w-full"
        >
          حذف المستخدم
          {isPending && <Loader className="mr-2" />}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
